import React from 'react';
import { VisibilityContext } from '../../vendor/react-horizontal-scrolling-menu';
import { minSwipeDistance } from '../../vendor/react-horizontal-scrolling-menu/constants';

type ScrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;

export const useSwipe = () => {
  const [touchStart, setTouchStart] = React.useState<number | undefined>(0);
  const [touchEnd, setTouchEnd] = React.useState<number | undefined>(0);

  // eslint-disable-next-line unicorn/consistent-function-scoping
  const onTouchStart = () => (ev: React.TouchEvent) => {
    setTouchEnd(ev.targetTouches[0].clientX);
    setTouchStart(ev.targetTouches[0].clientX);
  };

  // eslint-disable-next-line unicorn/consistent-function-scoping
  const onTouchMove = () => (ev: React.TouchEvent) => {
    setTouchEnd(ev.targetTouches[0].clientX);
  };

  const onTouchEnd = (apiObject: ScrollVisibilityApiType) => () => {
    if (!touchStart || !touchEnd) return false;
    const distance = touchStart - touchEnd;
    const isSwipe = Math.abs(distance) > minSwipeDistance;
    const isLeftSwipe = distance < minSwipeDistance;
    if (isSwipe) {
      if (isLeftSwipe) {
        apiObject.scrollPrev();
      } else {
        apiObject.scrollNext();
      }
    }
  };

  return { onTouchStart, onTouchEnd, onTouchMove };
};
